export const API_PATH = process.env.NODE_ENV === 'development' 
  ? `http://localhost:3000/dev` 
  : `https://77ykoccvpa.execute-api.eu-central-1.amazonaws.com/v2`